import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16f5b981")

_pushScopeId("data-v-16f5b981")
const _hoisted_1 = {
  key: 0,
  class: "loading-content"
}
const _hoisted_2 = { class: "content w-28 h-28" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_LoadingIcon, { class: "w-28 h-28" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})